import * as React from 'react';
import { SearchBox } from '@elastic/react-search-ui';
import glassIcon from '../../icons/magnifying-glass.svg';

export default function OpenSearchSearchBox() {
  return (
    <div className='block block--search-box'>
      <div className="search-icon">
        <img src={glassIcon} alt=""/>
      </div>

      <SearchBox searchAsYouType={true}/>
    </div>
  )
}
